const pageBlockGutters = { mobile: "small", tablet: "gutter" };
export {
  pageBlockGutters
};
